<template>
  <div class="shortcuts-container">
    <div class="periods-container">
      <button
        v-for="(shortcut, i) in shortcuts"
        :key="i"
        class="mx-btn mx-btn-text"
        @click="selectPeriod(emit, shortcut)"
      >
        {{ shortcut.label }}
      </button>
    </div>
  </div>
</template>

<script>
import {
  buildCurrentRange,
  buildFutureRange,
  buildPreviousRange
} from "@/lib/dates.js";

export default {
  props: {
    emit: {
      type: Function,
      default: null
    },
    periods: {
      type: Array,
      default: () => ["current", "previous"]
    }
  },
  data() {
    return {
      current: [
        {
          label: "Today",
          range: "day",
          single: true,
          current: true
        },
        {
          label: "Current Week",
          range: "week"
        },
        {
          label: "Current Month",
          range: "month"
        },
        {
          label: "Current Quarter",
          range: "quarter"
        },
        {
          label: "Current Year",
          range: "year"
        }
      ],
      previous: [
        {
          label: "Yesterday",
          range: "day",
          single: true,
          previous: true
        },
        {
          label: "Previous Week",
          range: "week",
          previous: true
        },
        {
          label: "Previous Month",
          range: "month",
          previous: true
        },
        {
          label: "Previous 30 Days",
          range: "days",
          offset: [0, 30],
          previous: true
        },
        {
          label: "Previous Quarter",
          range: "quarter",
          previous: true
        },
        {
          label: "Previous Year",
          range: "year",
          previous: true
        }
      ],
      future: [
        {
          label: "Tomorrow",
          range: "day",
          single: true,
          future: true
        },
        {
          label: "Next Week",
          range: "week",
          future: true
        },
        {
          label: "Next Month",
          range: "month",
          future: true
        },
        {
          label: "Next 30 Days",
          range: "days",
          offset: [0, 30],
          future: true
        },
        {
          label: "Next Quarter",
          range: "quarter",
          future: true
        },
        {
          label: "Next Year",
          range: "year",
          future: true
        }
      ],
      shortcuts: []
    };
  },
  created() {
    this.buildShortcuts();
  },
  methods: {
    buildShortcuts() {
      let shortcuts = [];
      this.periods.forEach(
        (period) => (shortcuts = shortcuts.concat(this[period]))
      );
      // Custom sort function to sort all single day options to the top in the correct order
      this.shortcuts = shortcuts.sort((a, b) => {
        if (a.single) {
          if (a.previous) {
            if (b.current) {
              return 1;
            }
            if (b.future) {
              return -1;
            }
          }
          if (a.future) {
            if (b.current) {
              return 1;
            }
            if (b.previous) {
              return 1;
            }
          }
          return -1;
        }
        return 1;
      });
    },
    selectPeriod(emit, shortcut) {
      let rangeFunction = buildCurrentRange;
      if (shortcut.previous) {
        rangeFunction = buildPreviousRange;
      }
      if (shortcut.future) {
        rangeFunction = buildFutureRange;
      }
      const range = rangeFunction(shortcut.range, shortcut.offset);
      emit(range);
    }
  }
};
</script>

<style lang="scss" scoped>
.periods-container {
  display: flex;
  flex-direction: column;
}

.shortcuts-container {
  display: flex;
  flex-direction: column;
}
</style>
